/* global axios */
import ApiClient from './ApiClient';

class FeatureFlagAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get() {
    return axios.get(`feature_flags/last`);
  }
}

export default new FeatureFlagAPI();
